/// APPROVED HOURS
export const APPROVE_HOURS = 'APPROVE_HOURS';
export const CM_LM_LOAD_APPROVED_HOURS_WEEK = 'CM_LM_LOAD_APPROVED_HOURS_WEEK';
export const COUNT_UNAPPROVED_HOURS_WEEK = 'COUNT_UNAPPROVED_HOURS_WEEK';
export const CREATE_APPROVED_HOURS = 'CREATE_APPROVED_HOURS';
export const PMO_LOAD_APPROVABLE_HOURS = 'PMO_LOAD_APPROVABLE_HOURS';
export const SET_LOADING_FLAG_FOR_APPROVED_HOUR_STATE = 'SET_LOADING_FLAG_FOR_APPROVED_HOUR_STATE';

/// ATTRIBUTES
export const CREATE_ATTRIBUTE = 'CREATE_ATTRIBUTE';
export const DELETE_ATTRIBUTE = 'DELETE_ATTRIBUTE';
export const LOAD_ALL_ATTRIBUTES = 'LOAD_ALL_ATTRIBUTES';
export const LOAD_DEFAULT_ATTRIBUTES = 'LOAD_DEFAULT_ATTRIBUTES';
export const PROJECT_SET_ATTRIBUTE_VALUE = 'PROJECT_SET_ATTRIBUTE_VALUE';
export const PROJECT_SET_ATTRIBUTE_VALUES = 'PROJECT_SET_ATTRIBUTE_VALUES';
export const SET_LOADING_FLAG_FOR_ATTRIBUTE_STATE = 'SET_LOADING_FLAG_FOR_ATTRIBUTE_STATE';

/// CODE VALUES
export const LOAD_FOR_ATTRIBUTE = 'LOAD_FOR_ATTRIBUTE';

/// COMMANDER
export const CLEAR_COMMANDER = 'CLEAR_COMMANDER';

/// CONTRACTS
export const LOAD_CONTRACTS = 'LOAD_CONTRACTS';
export const SET_LOADING_FLAG_FOR_CONTRACT_STATE = 'SET_LOADING_FLAG_FOR_CONTRACT_STATE';
export const SYNC_CONTRACTS = 'SYNC_CONTRACTS';

/// CUSTOMERS
export const LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
export const SET_LOADING_FLAG_FOR_CUSTOMER_STATE = 'SET_LOADING_FLAG_FOR_CUSTOMER_STATE';
export const SYNC_CUSTOMERS = 'SYNC_CUSTOMERS';

/// EVENTS
export const PUSH_ERROR_EVENT = 'PUSH_ERROR_EVENT';
export const PUSH_SUCCESS_EVENT = 'PUSH_SUCCESS_EVENT';
export const PUSH_WARNING_EVENT = 'PUSH_WARNING_EVENT';

/// FLOATING TASKS
export const CREATE_FLOATING_TASK = 'CREATE_FLOATING_TASK';
export const CREATE_FLOATING_TIMER = 'CREATE_TIMER';
export const DELETE_FLOATING_TASK = 'DELETE_FLOATING_TASK';
export const IS_DELETABLE_FLOATING_TASK = 'IS_DELETABLE_FLOATING_TASK';
export const INVALIDATE_FLOATING_TASK = 'INVALIDATE_FLOATING_TASK';
export const LOAD_ALL_FLOATING_TASKS = 'LOAD_ALL_FLOATING_TASKS';
export const MERGE_FLOATING_TASK_EXISTING = 'MERGE_FLOATING_TASK_EXISTING';
export const MERGE_FLOATING_TASK_NEW = 'MERGE_FLOATING_TASK_NEW';
export const PM_LOAD_ALL_FLOATING_TASKS = 'PM_LOAD_ALL_FLOATING_TASKS';
export const PMO_DELETE_FLOATING_TASK = 'PMO_DELETE_FLOATING_TASK';
export const PMO_LOAD_ALL_FLOATING_TASKS = 'PMO_LOAD_ALL_FLOATING_TASKS';
export const REASSIGN_FLOATING_TASK = 'REASSIGN_FLOATING_TASK';
export const RETURN_FLOATING_TASK = 'RETURN_FLOATING_TASK';
export const SET_LOADING_FLAG_FOR_FLOATING_TASK_STATE = 'SET_LOADING_FLAG_FOR_FLOATING_TASK_STATE';
export const VALIDATE_FLOATING_TASK = 'VALIDATE_FLOATING_TASK';

/// CUSTOMER GROUPS
export const CREATE_CUSTOMER_GROUP_PROJECT = 'CREATE_CUSTOMER_GROUP_PROJECT';
export const DELETE_CUSTOMER_GROUP_PROJECT = 'DELETE_CUSTOMER_GROUP_PROJECT';
export const LOAD_CUSTOMER_GROUPS = 'LOAD_CUSTOMER_GROUPS';
export const LOAD_CUSTOMER_GROUPS_BY_PROJECT = 'LOAD_CUSTOMER_GROUPS_BY_PROJECT';
export const SAVE_CUSTOMER_GROUP = 'SAVE_CUSTOMER_GROUP';
export const SET_LOADING_FLAG_FOR_CUSTOMER_GROUP_STATE = 'SET_LOADING_FLAG_FOR_CUSTOMER_GROUP_STATE';

/// LOGENTRY

export const CREATE_LOGENTRY = 'CREATE_LOGENTRY';
export const CREATE_COMMAND_LOGENTRY = 'CREATE_COMMAND_LOGENTRY';
export const DELETE_LOGENTRY = 'DELETE_LOGENTRY';
export const LOAD_LOGENTRIES_BY_TASK = 'LOAD_LOGENTRIES_BY_TASK';
export const LOAD_LOGENTRIES_BY_TIMESHEET = 'LOAD_LOGENTRIES_BY_TIMESHEET';
export const LOAD_LOGENTRIES_BY_TIMESHEET_TASKS = 'LOAD_LOGENTRIES_BY_TIMESHEET_TASKS';
export const LOAD_LOGENTRIES_ON_DATE = 'LOAD_LOGENTRIES_ON_DATE';
export const LOAD_LOGENTRIES_ON_DATE_FOR_USER = 'LOAD_LOGENTRIES_ON_DATE_FOR_USER';
export const LOAD_LOGENTRIES_ON_WEEK = 'LOAD_LOGENTRIES_ON_WEEK';
export const LOAD_LOGENTRIES_ON_WEEK_FOR_USER = 'LOAD_LOGENTRIES_ON_WEEK_FOR_USER';
export const PMO_CREATE_LOGENTRY = 'PMO_CREATE_LOGENTRY';
export const PMO_DELETE_LOGENTRY = 'PMO_DELETE_LOGENTRY';
export const PMO_EDIT_LOGENTRY_STATUS = 'PMO_EDIT_LOGENTRY_STATUS';
export const PMO_UPDATE_LOGENTRY = 'PMO_UPDATE_LOGENTRY';
export const PMO_UPDATE_LOGENTRY_TASK = 'PMO_UPDATE_LOGENTRY_TASK';
export const SET_LOADING_FLAG_FOR_LOGENTRY_STATE = 'SET_LOADING_FLAG_FOR_LOGENTRY_STATE';
export const STOP_TIMER_LOGENTRY = 'STOP_TIMER_LOGENTRY';
export const UPDATE_LOGENTRY = 'UPDATE_LOGENTRY';
export const UPDATE_LOGENTRY_TASK = 'UPDATE_LOGENTRY_TASK';

/// NOTIFICATIONS

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const DELETE_ALL_NOTIFICATIONS = 'DELETE_ALL_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const LOAD_NOTIFICATIONS_PAGE = 'LOAD_NOTIFICATIONS_PAGE';
export const LOAD_UNREAD_NOTIFICATIONS_PAGE_COUNT = 'LOAD_UNREAD_NOTIFICATIONS_PAGE_COUNT';
export const MARK_ALL_NOTIFICATIONS_AS_READ = 'MARK_ALL_NOTIFICATIONS_AS_READ';
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_NOTIFICATION_AS_UNREAD = 'MARK_NOTIFICATION_AS_UNREAD';
export const SET_LOADING_FLAG_FOR_NOTIFICATION_STATE = 'SET_LOADING_FLAG_FOR_NOTIFICATION_STATE';
export const UNDELETE_NOTIFICATION = 'UNDELETE_NOTIFICATION';

/// PROJECTS
export const APPROVE_HOURS_PROJECT = 'APPROVE_HOURS_PROJECT';
export const ARCHIVE_PROJECT = 'ARCHIVE_PROJECT';
export const CHECK_PROJECT_NAME = 'CHECK_PROJECT_NAME';
export const CHECK_PROJECT_NAME_CV = 'CHECK_PROJECT_NAME_CV';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const EXPORT_PROJECTS = 'EXPORT_PROJECTS';
export const IS_DELETABLE = 'IS_DELETABLE';
export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const LOAD_PROJECTS_BY_USER = 'LOAD_PROJECTS_BY_USER';
export const LOAD_MY_PROJECTS_FOR_WEEK_APPROVAL = 'LOAD_MY_PROJECTS_FOR_WEEK_APPROVAL';
export const LOAD_OTHER_PROJECTS_FOR_WEEK_APPROVAL = 'LOAD_OTHER_PROJECTS_FOR_WEEK_APPROVAL';
export const PM_LOAD_ALL_PROJECTS = 'PM_LOAD_ALL_PROJECTS';
export const PM_LOAD_ALL_PROJECTS_WITHOUT_TASKS = 'PM_LOAD_ALL_PROJECTS_WITHOUT_TASKS';
export const PM_LOAD_ARCHIVED_PROJECTS = 'PM_LOAD_ARCHIVED_PROJECTS';
export const PM_LOAD_UNARCHIVED_PROJECTS = 'PM_LOAD_UNARCHIVED_PROJECTS';
export const PMO_LOAD_ALL_PROJECTS = 'PMO_LOAD_ALL_PROJECTS';
export const PMO_LOAD_ALL_PROJECTS_FOR_USERS_OVERVIEW = 'PMO_LOAD_ALL_PROJECTS_FOR_USERS_OVERVIEW';
export const PMO_LOAD_ARCHIVED_PROJECTS = 'PMO_LOAD_ARCHIVED_PROJECTS';
export const PMO_LOAD_UNARCHIVED_PROJECTS = 'PMO_LOAD_UNARCHIVED_PROJECTS';
export const SET_LOADING_FLAG_FOR_OTHER_PROJECT_STATE = 'SET_LOADING_FLAG_FOR_OTHER_PROJECT_STATE';
export const SET_LOADING_FLAG_FOR_PROJECT_STATE = 'SET_LOADING_FLAG_FOR_PROJECT_STATE';
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const UNARCHIVE_PROJECT = 'UNARCHIVE_PROJECT';
export const GET_UNBILLED_TIME_ON_PROJECT = 'GET_UNBILLED_TIME_PROJECT';

/// TASHI
export const CLEAR_VERSION_ERROR = 'CLEAR_VERSION_ERROR';
export const LOAD_VERSION = 'LOAD_VERSION';
export const SET_LOADING_FLAG_FOR_TASHI_STATE = 'SET_LOADING_FLAG_FOR_TASHI_STATE';

/// TASKS

export const CLOSE_TASK = 'CLOSE_TASK';
export const CREATE_TASK = 'CREATE_TASK';
export const CREATE_TIMER = 'CREATE_TIMER';
export const DELETE_FAVORITE_TASK = 'DELETE_FAVORITE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const EDIT_TASK = 'EDIT_TASK';
export const IS_DELETABLE_TASK = 'IS_DELETABLE_TASK';

export const LOAD_FAVORITE_TASKS = 'LOAD_FAVORITE_TASKS';
export const LOAD_MOST_FREQUENTLY_USED_TASKS = 'LOAD_MOST_FREQUENTLY_USED_TASKS';
export const LOAD_OTHER_TASKS = 'LOAD_OTHER_TASKS';
export const LOAD_RECENTLY_ASSIGNED_TASKS = 'LOAD_RECENTLY_ASSIGNED_TASKS';
export const LOAD_TASKS = 'LOAD_TASKS';
export const LOAD_TASKS_ASSIGNABLE_TO_USER_BY_PROJECT = 'LOAD_TASKS_ASSIGNABLE_TO_USER_BY_PROJECT';
export const LOAD_TASKS_BY_PROJECT = 'LOAD_TASKS_BY_PROJECT';
export const LOAD_TASKS_BY_USER = 'LOAD_TASKS_BY_USER';
export const PM_LOAD_ALL_TASKS = 'PM_LOAD_ALL_TASKS';
export const PMO_LOAD_ALL_TASKS = 'PMO_LOAD_ALL_TASKS';
export const REOPEN_TASK = 'REOPEN_TASK';
export const SET_COLOR_TASK = 'SET_COLOR_TASK';
export const SET_FAVORITE_TASK = 'SET_FAVORITE_TASK';
export const SET_LOADING_FLAG_FOR_TASK_STATE = 'SET_LOADING_FLAG_FOR_TASK_STATE';
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK';

/// TIME

export const GET_TIME_SPENT_ON_PROJECT = 'GET_TIME_SPENT_ON_PROJECT';
export const GET_TIME_SPENT_ON_PROJECT_BY_USER = 'GET_TIME_SPENT_ON_PROJECT_BY_USER';
export const GET_TIME_SPENT_ON_TASK = 'GET_TIME_SPENT_ON_TASK';
export const GET_TIME_SPENT_ON_TASK_BY_USER = 'GET_TIME_SPENT_ON_TASK_BY_USER';
export const SET_LOADING_FLAG_FOR_TIME_STATE = 'SET_LOADING_FLAG_FOR_TIME_STATE';

/// TIMESHEET

export const APPROVE_TIMESHEET = 'APPROVE_TIMESHEET';
export const CM_LM_LOAD_TIMESHEETS_BY_WEEK = 'CM_LM_LOAD_TIMESHEETS_BY_WEEK';
export const DELETE_TIMESHEET = 'DELETE_TIMESHEET';
export const EDIT_TIMESHEET_STATUS = 'EDIT_TIMESHEET_STATUS';
export const LOAD_TIMESHEETS_BY_USER_AND_WEEK = 'LOAD_TIMESHEETS';
export const LOAD_TIMESHEETS_BY_WEEK = 'LOAD_TIMESHEETS_BY_WEEK';
export const PMO_LOAD_TIMESHEETS_BY_YEAR = 'PMO_LOAD_TIMESHEETS_BY_YEAR';
export const PMO_LOAD_TIMESHEETS_BY_RANGE = 'PMO_LOAD_TIMESHEETS_BY_RANGE';
export const REJECT_APPROVED_HOURS = 'REJECT_APPROVED_HOURS';
export const SET_LOADING_FLAG_FOR_TIMESHEET_STATE = 'SET_LOADING_FLAG_FOR_TIMESHEET_STATE';
export const SET_TIMESHEET_STATUS_TO_ENTRY = 'SET_TIMESHEET_STATUS_TO_ENTRY';
export const SUBMIT_TIMESHEET = 'SUBMIT_TIMESHEET';

/// USERS
export const CHANGE_WEEKLY_QUOTA_FOR_USER = 'CHANGE_WEEKLY_QUOTA_FOR_USER';
export const CM_LM_LOAD_USERS_FOR_STAFF_OVERVIEW = 'CM_LM_LOAD_USERS_FOR_STAFF_OVERVIEW';
export const LOAD_ALL_USERS_FOR_USERS_OVERVIEW = 'LOAD_ALL_USERS_FOR_USERS_OVERVIEW';
export const LOAD_CURRENT_USER = 'LOAD_CURRENT_USER';
export const LOAD_USERS_NO_LONGER_ASSIGNED = 'LOAD_USERS_NO_LONGER_ASSIGNED';
export const LOAD_PMS = 'LOAD_PMS';
export const LOAD_REGULAR_USERS = 'LOAD_REGULAR_USERS';
export const LOAD_SPONSORS = 'LOAD_SPONSORS';
export const LOAD_USER_BY_ID = 'LOAD_USER_BY_ID';
export const LOAD_ALL_USERS = 'LOAD_ALL_USERS';
export const LOAD_USERS_BY_TASK = 'LOAD_USERS_BY_TASK';
export const SET_LOADING_FLAG_FOR_USER_STATE = 'SET_LOADING_FLAG_FOR_USER_STATE';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const SYNC_USERS_WITH_LDAP = 'SYNC_USERS_WITH_LDAP';
export const SYNC_USER_IDS_WITH_AKIRA = 'SYNC_USER_IDS_WITH_AKIRA';

/// USERTASKS
export const ASSIGN_USER_TO_TASK = 'ASSIGN_USER_TO_TASK';
export const CREATE_USERTASK = 'CREATE_USERTASK';
export const LOAD_QUOTA_HISTORY_BY_USER_TASK = 'LOAD_QUOTA_HISTORY_BY_USER_TASK';
export const LOAD_USERTASK_BY_ID = 'LOAD_USERTASK_BY_ID';
export const LOAD_USERTASKS_BY_USER = 'LOAD_USERTASKS_BY_USER';
export const LOAD_USERTASKS_BY_TASK = 'LOAD_USERTASKS_BY_TASK';
export const PM_LOAD_ALL_USERTASKS = 'PM_LOAD_ALL_USERTASKS';
export const SET_LOADING_FLAG_FOR_USERTASK_STATE = 'SET_LOADING_FLAG_FOR_USERTASK_STATE';
export const UNASSIGN_USER_FROM_TASK = 'UNASSIGN_USER_FROM_TASK';
export const UPDATE_USERTASK_ALIAS = 'UPDATE_USERTASK_ALIAS';
export const UPDATE_USERTASK_COLOR = 'UPDATE_USERTASK_COLOR';
export const UPDATE_USERTASK_FAVORITE = 'UPDATE_USERTASK_FAVORITE';
export const UPDATE_USERTASK_QUOTA = 'UPDATE_USERTASK_QUOTA';

// WEEK APPROVAL UI
export const TOGGLE_MY_PROJECT_OPEN = 'TOGGLE_MY_PROJECT_OPEN';
export const TOGGLE_OTHER_PROJECT_OPEN = 'TOGGLE_OTHER_PROJECT_OPEN';
export const TOGGLE_MY_TASK_OPEN = 'TOGGLE_MY_TASK_OPEN';
export const TOGGLE_OTHER_TASK_OPEN = 'TOGGLE_OTHER_TASK_OPEN';
export const UNFOLD_MY_PROJECT = 'UNFOLD_MY_PROJECT';
export const UNFOLD_OTHER_PROJECT = 'UNFOLD_OTHER_PROJECT';
export const UNFOLD_MY_TASK = 'UNFOLD_MY_TASK';
export const UNFOLD_OTHER_TASK = 'UNFOLD_OTHER_TASK';
export const FOLD_MY_PROJECT = 'FOLD_MY_PROJECT';
export const FOLD_OTHER_PROJECT = 'FOLD_OTHER_PROJECT';
export const FOLD_MY_TASK = 'FOLD_MY_TASK';
export const FOLD_OTHER_TASK = 'FOLD_OTHER_TASK';
export const RESET_MY_PROJECT_OPEN = 'RESET_MY_PROJECT_OPEN';
export const RESET_MY_TASK_OPEN = 'RESET_MY_TASK_OPEN';
export const RESET_OTHER_PROJECT_OPEN = 'RESET_OTHER_PROJECT_OPEN';
export const RESET_OTHER_TASK_OPEN = 'RESET_OTHER_TASK_OPEN';
export const SET_CURRENT_APPROVAL_WEEK = 'SET_CURRENT_APPROVAL_WEEK';



/** WEBPACK FOOTER **
 ** ./src/app/constants/actionTypes.js
 **/